import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGoal } from '../context/GoalContext';
import Header from '../components/Header';
import Input from '../components/Input';
import Button from '../components/Button';
import Card from '../components/Card';
import { calculateMonthly, formatCurrency } from '../utils/calculations';
import styles from './EditGoalScreen.module.css';

const accounts = [
  { id: 1, name: 'Everyday Savings', number: '4892' },
  { id: 2, name: 'Checking', number: '1180' },
  { id: 3, name: 'Travel Fund', number: '7723' }
];

const EditGoalScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getGoal, updateGoal, deleteGoal } = useGoal();
  const goal = getGoal(id);

  const [name, setName] = useState(goal?.name || '');
  const [amount, setAmount] = useState(goal?.amount || '');
  const [deadline, setDeadline] = useState(goal?.deadline || '');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  if (!goal) return null;

  const monthly = calculateMonthly(Number(amount), deadline);
  const canSave = name.trim().length > 0 && Number(amount) > 0 && deadline;
  const showCalc = Number(amount) > 0 && deadline;

  const account = accounts.find(a => a.id === goal.accountId);

  const handleSave = () => {
    updateGoal(parseInt(id), { name, amount: Number(amount), deadline });
    navigate(`/goal/${id}`, { state: { toast: 'Goal updated' } });
  };

  const handleDelete = () => {
    deleteGoal(parseInt(id));
    navigate('/');
  };

  return (
    <div className={styles.screen}>
      <Header title="Edit goal" />

      <div className={styles.body}>
        <Input
          label="Goal name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="What are you saving for?"
          id="edit-name"
        />

        <Input
          label="Target amount"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
          type="number"
          prefix="₹"
          id="edit-amount"
        />

        <Input
          label="Target date"
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
          type="date"
          id="edit-deadline"
        />

        {/* Account (disabled) */}
        <div className={styles.accountField}>
          <label className={styles.accountLabel}>Account</label>
          <div className={styles.accountValue}>
            <span>{account?.name}</span>
            <span className={styles.accountNum}>••••{account?.number}</span>
          </div>
          <p className={styles.accountNote}>To change accounts, archive this goal and create a new one.</p>
        </div>

        {/* Live calc */}
        {showCalc && (
          <Card className={styles.calcCard}>
            <div className={styles.calcRow}>
              <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
                <path d="M9 2.25C5.27 2.25 2.25 5.27 2.25 9S5.27 15.75 9 15.75 15.75 12.73 15.75 9 12.73 2.25 9 2.25zm0 2.25v5.25l3.375 2.025-.675 1.125L8.25 10.5V4.5H9z" fill="#00B8A9"/>
              </svg>
              <p className={styles.calcText}>
                Save <strong>{formatCurrency(monthly)}/month</strong> to reach your updated goal
              </p>
            </div>
          </Card>
        )}
      </div>

      <div className={styles.footer}>
        <Button label="Save changes" onClick={handleSave} disabled={!canSave} />

        {!showDeleteConfirm ? (
          <button className={styles.deleteLink} onClick={() => setShowDeleteConfirm(true)}>
            Delete goal
          </button>
        ) : (
          <div className={styles.confirmDelete}>
            <p className={styles.confirmText}>Are you sure? This can't be undone.</p>
            <div className={styles.confirmActions}>
              <button className={styles.cancelBtn} onClick={() => setShowDeleteConfirm(false)}>Cancel</button>
              <button className={styles.deleteConfirmBtn} onClick={handleDelete}>Yes, delete</button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EditGoalScreen;
